export default __webpack_public_path__ + "863985d67436f8342e2d913563648040.woff2";